"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Utils = require("../Utils");
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
const breakpoints = {
  lg: 992,
  md: 768,
  sm: 576,
  xl: 1200,
  xs: 0
};
function getWidth(span) {
  if (!span) return '100%';
  const width = span / 12 * 100;
  return "".concat(width, "%");
}
const breakpointKeys = ['xs', 'sm', 'md', 'lg'];
const Col = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  padding-right: 5px;\n  padding-left: 5px;\n  ", "\n  ", "\n  flex: 1 1 auto;\n  width: auto;\n\n  ", "\n"])), (0, _Utils.parseProp)('margin'), (0, _Utils.parseProp)('padding'), props => breakpointKeys.map(key => {
  if (!props[key]) return '';
  if (key === 'xs') {
    return (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          flex-basis: ", ";\n          max-width: ", ";\n        "])), getWidth(props[key]), getWidth(props[key]));
  }
  return (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        @media (min-width: ", "px) {\n          flex-basis: ", ";\n          max-width: ", ";\n        }\n      "])), breakpoints[key], getWidth(props[key]), getWidth(props[key]));
}));
var _default = exports.default = Col;